<template>
  <div class="field-list position-relative">
    <!-- Label del campo (si showLabel es true) -->
    <small
      v-if="showLabel && field.label"
      :for="computedFieldId"
      class="form-label w-100"
    >
      <strong>
        {{ $t(field.label) }}
      </strong>
    </small>
    <br v-if="showLabel && field.label" />

    <!-- MODO FILTRO -->
    <FilterFieldList
      v-if="mode === 'edit' && isFilter"
      :field="field"
      :value="value"
      :fieldId="computedFieldId"
      :filterOperator="filterOperator"
      :lists="lists"
      @input="$emit('input', $event)"
      @filter-operator-change="$emit('filter-operator-change', $event)"
    />

    <!-- MODO EDIT -->
    <EditFieldList
      v-else-if="effectiveFieldMode === 'edit'"
      :field="field"
      :value="value"
      :fieldId="computedFieldId"
      :editingFields="editingFields"
      :lists="lists"
      :option-id-filter="optionIdFilter"
      :disableLock="disableLock"
      :calculated="calculated"
      :record-item="recordItem"
      @input="$emit('input', $event)"
      @update:editingFields="$emit('update:editingFields', $event)"
    />

    <!-- MODO VIEW -->
    <ViewFieldList
      v-else-if="effectiveFieldMode === 'view'"
      :field="field"
      :value="value"
      :item="item"
      :modelName="modelName"
      :isGroupModel="isGroupModel"
      :lists="lists"
    />
  </div>
</template>

<script>
import EditFieldList from "./list/editField.vue";
import ViewFieldList from "./list/viewField.vue";
import FilterFieldList from "./list/filterField.vue";
import fieldEditableByMixin from "@/mixins/fieldEditableByMixin";

export default {
  name: "FieldList",
  mixins: [fieldEditableByMixin],
  components: {
    EditFieldList,
    ViewFieldList,
    FilterFieldList,
  },
  props: {
    field: {
      type: Object,
      required: true,
    },
    value: {
      type: [String, Number, Object, Array],
      default: null,
    },
    mode: {
      type: String,
      required: true,
      validator: (value) => ["edit", "view"].includes(value),
    },
    fieldId: {
      type: String,
      default: null,
    },
    editingFields: {
      type: String,
      default: "",
    },
    item: {
      type: Object,
      default: null,
    },
    modelName: {
      type: String,
      default: "",
    },
    isGroupModel: {
      type: Boolean,
      default: false,
    },
    lists: {
      type: Array,
      default: () => [],
    },
    /** En FormV2: ids permitidos; sin prop = sin filtro; [] = ninguna opción */
    optionIdFilter: Array,
    showLabel: {
      type: Boolean,
      default: false,
    },
    disableLock: {
      type: Boolean,
      default: false,
    },
    calculated: {
      type: Boolean,
      default: false,
    },
    isFilter: {
      type: Boolean,
      default: false,
    },
    filterOperator: {
      type: String,
      default: "=",
    },
    recordItem: {
      type: Object,
      default: null,
    },
  },
  computed: {
    computedFieldId() {
      return this.fieldId || `field-list-${this.field.key}`;
    },
  },
};
</script>

<style scoped>
.field-list {
  width: 100%;
}
</style>
